export default __webpack_public_path__ + "static/media/right-arrow.e68f6baf.svg";